import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Event, ActivationEnd, RoutesRecognized, NavigationEnd } from '@angular/router';
import { LogsSessionService } from './core/services/logs-session.service';
import { filter, map, startWith, switchMap, take, takeUntil } from 'rxjs/operators';
import { Subject, Subscription, interval } from 'rxjs';
import { UserProfileService } from './core/services/user.service';
import Swal from 'sweetalert2';
import { LogsService } from './core/services/logs.service';
import { detectBrowserName, Decrypt , Encrypt  } from './pages/functions/functions';
import { SettingsService } from 'src/app/core/services/settings.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsService } from './core/services/notifications.service';
import { ToastsService } from './core/services/toasts.service';
import { Usuario } from './core/models/usuario.model';
import { ToastrService } from 'ngx-toastr';
import { MantenimientosService } from './core/services/mantenimientos.service';
import { IdleService } from './core/services/IdleService.service';
import { EventosService } from './core/services/eventos.service';
import moment from 'moment';
import { AuditService } from './core/services/audit.service';
import { InactivityService } from './core/services/inactivity.service';
import { SocketService } from './core/services/socket.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements  OnInit,OnDestroy  {
  titulo:string = '';
  tituloSubs$!:Subscription;
  currentRoute!: string;
  url:string = '';
  public usuario: Usuario;

  cantidadNotificaciones = 0;
  private notificacionesVistas = new Set<number>();
  private notificationsSubscription?: Subscription;
  notificaciones: any[] = [];
  profileStorage = localStorage.getItem('profile');
  profile = this.profileStorage ? Decrypt(this.profileStorage) : null;
  keyIdStorage = localStorage.getItem('key_id');
  keyId = this.keyIdStorage ? Decrypt(this.keyIdStorage) : null;
  private destroy$ = new Subject<void>();


  constructor(private router:Router,private route:ActivatedRoute,
    private logservice:LogsSessionService,
    private usuerService:UserProfileService, 
    private logService:LogsService,
    private settingsService:SettingsService,
    private modalService: NgbModal,
    private notificationsService:NotificationsService,
    private toastsService:ToastsService,   
    public toastr: ToastrService,
    private mantenimientosService:MantenimientosService,
    private idleService: IdleService,
    private eventosService:EventosService,
    private auditService: AuditService,
    private inactivityService:InactivityService,
     private socketService: SocketService
    ) {
      
    // this.tituloSubs$ = this.getArgumentosRuta()
    // .subscribe( ({titulo}) =>{ return titulo; });

     this.usuario = this.usuerService.usuario;
  
  //  console.log(this.usuerService.usuario);

  
this.escucharNotificaciones();


  }

escucharNotificaciones(): void {

  this.socketService
    .escuchar('CRON_NOTIFICATION')
    .pipe(
      takeUntil(this.destroy$)
    )
    .subscribe((data: any) => {

      console.log('🔔 Notificación recibida:', data);

      switch (data.type) {

        case 'USER_CLEANUP':

          this.toastsService.showInfo(
            data.message,
            data.title
          );

          break;


        case 'CALIBRATION_EXPIRING':
          this.toastsService.showCalibrationWarning(data);
          break;


        case 'CALIBRATION_EXPIRED':
          this.toastsService.showCalibrationExpired(data);
          break;


        default:

          this.toastsService.showInfo(
            data.message,
            data.title
          );

          break;

      }

    });

}


 

   ngOnInit() {
   
     if (this.usuerService.token) {
          this.inactivityService.startWatching();
       
      }

         this.navigationAudit();
          this.navigationLogs();

   
  // const intervaloEnMilisegundos = 20000; // 20 segundos

  //   setInterval(() => {
  //     this.alarmaError();
  //   }, intervaloEnMilisegundos);

  //   if(localStorage.getItem('token') !== null){
  //     setInterval(()=>{
  //       // this.getAlertsMant();
  //       this.getVigencia();
  //       // this.getAutorizations();
  //     },intervaloEnMilisegundos);
  //   }
  }

navigationLogs(){
     this.router.events.pipe(filter(event => event instanceof RoutesRecognized))
    .subscribe(async(event) => {
    
      localStorage.setItem('rout',Encrypt(event['url'.toString()]));
      let data = {
        access: await this.getArgumentosRuta(),
        move:"Navegación",
        observation:event['url'],
        user_id:localStorage.getItem('key_id') ? this.keyId : ''
      }
      let intervalo = 1 * 60 * 1000;
      // if(localStorage.getItem('token')){
      //   this.getAutorizations();
      //   interval(intervalo)
      //   .pipe(take(1)) 
      //   .subscribe(() => {
      //     this.getAlertsMant();
      //     // this.getVigencia();
      //     // this.getAutorizations();
      //   });
      // }
     
       this.logservice.postLogs_Sessions(data).subscribe(resp =>{
        //  
       })

    });
}
  navigationAudit(){
     /*
    |--------------------------------------------------------------------------
    | NAVIGATION AUDIT
    |--------------------------------------------------------------------------
    */

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {

        /*
        |--------------------------------------------------------------------------
        | IGNORE ROUTES
        |--------------------------------------------------------------------------
        */

        const ignoredRoutes = [

          '/login',
          '/404',
          '/access-denied'

        ];

        const shouldIgnore = ignoredRoutes.some(route =>
          event.urlAfterRedirects.includes(route)
        );

        if (shouldIgnore) {
          return;
        }

        /*
        |--------------------------------------------------------------------------
        | REGISTER NAVIGATION
        |--------------------------------------------------------------------------
        */

        this.auditService.registrar({

          roleName:
            Decrypt(this.usuerService.usuario.profile) || 'User',

          responsibleUser:
            Decrypt(this.usuerService.usuario.name) || 'Unknown',

          actionName: 'NAVEGACION',

          moduleName:
            this.getModuleName(event.urlAfterRedirects),

          movement:
            `Usuario ha ingreado  ${event.urlAfterRedirects}`,

          urlEndpoint:
            event.urlAfterRedirects,

          statusName: 'CORRECTO',

          createdBy:
            Decrypt(this.usuerService.usuario.name) || 'System',

          createdAt:
            new Date()

        });

      });
  }

procesarNotificaciones(resp: any[]) {

  const profile = Decrypt(
    localStorage.getItem('profile')
  );

  const userId = Number(
    Decrypt(localStorage.getItem('key_id'))
  );

  const nuevasNotificaciones: any[] = [];

  for (const element of resp) {

    // Administrador
    if (profile === 'Administrador') {

      if (element.status === false) {

        nuevasNotificaciones.push({
          id: element.id,
          tipo: 'autorizacion',
          titulo: 'Solicitud de autorización',
          mensaje: `Solicitud realizada por ${Decrypt(element.name)} ${Decrypt(element.lastname)}`,
          fecha: new Date(),
          leida: false,
          data: element
        });

      }

    }

    // Usuario solicitante
    else {

      if (
        element.token_client &&
        element.status === true &&
        element.is_used === false &&
        element.user_id_client === userId &&
        element.is_invalid === false
      ) {

        nuevasNotificaciones.push({
          id: element.id,
          tipo: 'autorizacion',
          titulo: 'Solicitud autorizada',
          mensaje: 'Tu solicitud fue autorizada. Utiliza el token antes de que caduque.',
          fecha: new Date(),
          leida: false,
          data: element
        });

      }

    }

  }

  this.notificaciones = nuevasNotificaciones;

  this.cantidadNotificaciones =
    this.notificaciones.filter(x => !x.leida).length;

}

cargarNotificaciones(): void {

  this.notificationsService.getAutorizations()
    .subscribe({

      next: (resp: any) => {

        this.procesarNotificaciones(resp);

      },

      error: (error) => {

        console.error(
          'Error al cargar notificaciones:',
          error
        );

      }

    });

}


// getAutorizations(){
  
 
//    this.notificationsService.getAutorizations().subscribe(async (resp:any) => {
//       for (const key in resp) {
//           const element = resp[key];

           
//           if(this.profile === 'Administrador'){
//             if(element.status === false){  
//              await this.toastsService.showInfo('Solicitud de autorización',`Tienes unas autorizaciones pendientes, solicitada por ${Decrypt(element.name)} ${Decrypt(element.lastname)}`)
//             }
//           }else{
            
//             if(element.token_client && element.status === true && element.is_used === false && element.user_id_client === Number(this.keyId)  && element.is_invalid === false){ 
//                await this.toastsService.showInfo('Solicitud de autorización',`Ya fue autorizada la peticion utiliza el token antes de que caduque`)
//             }
//           }
        
//       }
//     })
//    }





separateURL(){
    let urlactual  = document.location.href;
    let divid = urlactual.split('/');
    return divid[4];
}

 






savelog(data:any){
  this.logService.postLogs(data);
}


async  getArgumentosRuta(){

    return new Promise(resolve =>{
     this.router.events.subscribe((event:Event) =>{
        // 
        if (event instanceof NavigationEnd) {
          resolve(this.separar( event.url));


      }
      // 
        });
      })
   }

   ngOnDestroy(): void {
     this.tituloSubs$.unsubscribe();

      this.destroy$.next();
    this.destroy$.complete();
   }

   separar(text:string){
    let texto = text;
    let name = texto.split('/');

    return name[2];
   }






   filtertipoEvento(id:number) {

    let result = [{
            id: 1,
            msg: 'administración del sistema'
        },
        {
            id: 2,
            msg: 'eventos de la UCC'
        },
        {
            id: 3,
            msg: 'eventos relacionados a los programas informáticos'
        },
        {
            id: 4,
            msg: 'eventos de comunicación'
        },
        {
            id: 5,
            msg: 'operaciones cotidianas'
        },
        {
            id: 6,
            msg: 'verificaciones realizadas por la autoridad fiscal o por proveedores autorizados por el SAT'
        },
        {
            id: 7,
            msg: 'exista una diferencia de más de 0.5 % tratándose de Hidrocarburos y Petrolíferos líquidos o de 1 % tratándose de Hidrocarburos y Petrolíferos gaseosos, en el volumen final del periodo, obtenido de sumar al volumen inicial en dicho periodo, las recepciones de producto y restar las entregas de producto, incluyendo las pérdidas por proceso'
        },
        {
            id: 8,
            msg: 'el volumen de existencias registrado al corte del día, es igual al registrado en el corte del día anterior y existen registros de entradas o salidas en el corte del día'
        },
        {
            id: 9,
            msg: ' el volumen de existencias registrado por cada tipo de Hidrocarburo o Petrolífero y sistema de medición es menor a cero'
        },
        {
            id: 10,
            msg: 'el volumen de existencias registrado en el corte del día varía con respecto al corte del día anterior y no existen registros de entradas o salidas en el corte del día'
        },
        {
            id: 11,
            msg: 'el volumen de salidas en un lapso de veinticuatro horas es mayor al volumen de entradas del mismo lapso más el volumen de existencias del corte del día anterior'
        },
        {
            id: 12,
            msg: 'calibración no vigente'
        },
        {
            id: 13,
            msg: ' intento de alteración de cualquier registro'
        },
        {
            id: 14,
            msg: 'registros incompletos o duplicados'
        },
        {
            id: 15,
            msg: ' problemas de comunicación'
        },
        {
            id: 16,
            msg: 'falla del medio de almacenamiento'
        },
        {
            id: 17,
            msg: ' falla en la red de comunicación'
        },
        {
            id: 18,
            msg: ' falla de energía'
        },
        {
            id: 19,
            msg: ' error en la transmisión de información'
        },
        {
            id: 20,
            msg: 'rechazos de inicio de sesión'
        },
        {
            id: 21,
            msg: 'paro de emergencia'
        }
    ]

    let data = result.filter(data => data.id === id);

    return data[0].msg;

}


  private getModuleName(url: string): string {

    if (url.includes('/usuarios')) {
      return 'Usuarios';
    }
    if (url.includes('/bitacoras')) {
      return 'Bitacoras';
    }
    if (url.includes('/conciliaciones')) {
      return 'Conciliaciones';
    }
    if (url.includes('/catalogos')) {
      return 'Catalogs';
    }
    if (url.includes('/inventarios')) {
      return 'Inventarios';
    }
    if (url.includes('/volumen')) {
      return 'Volumen';
    }
    if (url.includes('/transacciones')) {
      return 'Transacciones';
    }
    if (url.includes('/ajustes')) {
      return 'Ajustes';
    }
    if (url.includes('/financiero')) {
      return 'Financiero';
    }

    if (url.includes('/clients')) {
      return 'Clientes';
    }

    if (url.includes('/settings')) {
      return 'Ajustes';
    }

    if (url.includes('/reportes')) {
      return 'Reportes';
    }
    if (url.includes('/mantenimientos')) {
      return 'Manteniemientos';
    }

    if (url.includes('/dashboard')) {
      return 'Inicio';
    }

    return 'General';

  }

}
